import { render, staticRenderFns } from "./AcceptExtraTermsForm.vue?vue&type=template&id=778dfaf8&scoped=true"
import script from "./AcceptExtraTermsForm.vue?vue&type=script&lang=js"
export * from "./AcceptExtraTermsForm.vue?vue&type=script&lang=js"
import style0 from "./AcceptExtraTermsForm.vue?vue&type=style&index=0&id=778dfaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778dfaf8",
  null
  
)

export default component.exports